import { render, staticRenderFns } from "./UserMoney.vue?vue&type=template&id=8cc30f5c&scoped=true"
import script from "./UserMoney.vue?vue&type=script&lang=js"
export * from "./UserMoney.vue?vue&type=script&lang=js"
import style0 from "./UserMoney.vue?vue&type=style&index=0&id=8cc30f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc30f5c",
  null
  
)

export default component.exports